import styled from 'styled-components'

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0}
    ${props => props.theme.primitives.radius.radius2} ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.warning.surface};
  color: ${props => props.theme.colors.warning.onSurface};

  padding: ${props => props.theme.spacing.sp8};
  gap: ${props => props.theme.spacing.sp8};

  svg {
    min-height: ${props => props.theme.size.S};
    min-width: ${props => props.theme.size.S};
    color: ${props => props.theme.colors.warning.onSurface};
    fill: ${props => props.theme.colors.warning.onSurface};
  }
`

export const ActionRequiredContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp4};
`

export const AlertMessage = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const ActionRequiredInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`

export const SuccessContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0}
    ${props => props.theme.primitives.radius.radius2} ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.success.surface};
  color: ${props => props.theme.colors.success.onSurface};

  padding: ${props => props.theme.spacing.sp8};
  gap: ${props => props.theme.spacing.sp8};

  svg {
    min-height: ${props => props.theme.size.S};
    min-width: ${props => props.theme.size.S};
    color: ${props => props.theme.colors.success.onSurface};
    fill: ${props => props.theme.colors.success.onSurface};
  }
`
